/**
 * @fileOverview Cross
 */
export var Cell = function Cell(props) {
  return null;
};
Cell.displayName = 'Cell';


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/component/Cell.js
// module id = null
// module chunks = 